<template>
  <el-dialog
    title="请输入图形验证码"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="400px"
    class="dialog-code"
    @closed="onClosed"
  >
    <div class="body">
      <el-input v-model="code" :maxlength="4"></el-input>
      <img
        :src="img_code"
        class="img-code"
        @click="getImgCode"
        title="点击切换验证码"
      />
      <img
        class="img-refresh"
        src="@/assets/images/common/refresh@2x.png"
        @click="getImgCode"
      />
      <a class="lnk-refresh" @click="getImgCode"> 刷新 </a>
    </div>
    <div class="error">{{ error }}</div>
    <template v-slot:footer>
      <el-button class="btn-confirm" type="primary" @click="onClick"
        >确 定</el-button
      >
    </template>
    <a class="close" @click="dialogVisible = false"></a>
  </el-dialog>
</template>
<script>
export default {
  name: "ValidateCodeModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    cloedHanlder: {
      type: Function,
    },
    confirmHandler: {
      type: Function,
    },
  },
  data() {
    return {
      dialogVisible: false,
      code: "",
      key: "",
      img_code: "",
      error: "",
    };
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    },
  },
  async created() {
    this.dialogVisible = this.visible;
    await this.getImgCode();
  },
  methods: {
    async getImgCode() {
      let data = await this.$http.get("/api/app/captcha");
      this.img_code = data.img;
      this.key = data.key;
    },
    onClick() {
      if (!this.code) {
        this.error = "请输入图形验证码";
        return;
      }
      if (this.code.length < 4) {
        this.error = "图形验证码不足4位，请重新输入";
        return;
      }
      this.error = "";
      this.confirmHandler &&
        this.confirmHandler({ code: this.code, key: this.key });
    },
    onClosed() {
      if (this.cloedHanlder) {
        this.cloedHanlder();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-code {
  /deep/ {
    .el-dialog__header {
      padding: 19px 30px 20px 30px;
    }
    .el-dialog__title {
      font-size: 17px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
    }
    .el-dialog__headerbtn {
      display: none;
    }
    .el-dialog__body {
      padding: 0 30px;
    }
    .el-dialog__footer {
      padding: 7px 30px 30px 30px;
    }
    .el-input__inner {
      height: 46px;
      line-height: 46px;
    }
  }
  .body {
    display: flex;
    align-items: center;
  }
  .btn-confirm {
    width: 100%;
  }
  .img-code {
    margin: 0 15px 0 10px;
    width: 100px;
    height: 44px;
  }
  .lnk-refresh {
    cursor: pointer;
    white-space: nowrap;
    color: $primary-color;
  }
  .img-refresh {
    width: 16px;
    height: 16px;
    margin-right: 4px;
    cursor: pointer;
  }
  .error {
    color: #ff2d28;
    padding-top: 6px;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .close {
    position: absolute;
    width: 18px;
    height: 18px;
    background-image: url("~@/assets/images/common/close@2x.png");
    background-size: 100% 100%;
    cursor: pointer;
    right: 30px;
    top: 22px;
  }
}
</style>